/**
 * @typedef {object} WinterizationLogoProps
 * @property {string} className - The CSS class name for the logo container.
 */

/**
 * Renders the Winterization logo.
 * @param {WinterizationLogoProps} props The component props.
 * @returns {React.ReactElement<WinterizationLogoProps>} The rendered Winterization logo.
 */
export function WinterizationLogo({ className }) {
  return (
    <div className={className}>
      <svg width="48" height="48" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="100%" height="100%" fill="url(#paint0_linear_1812_4022)" />
        <path
          d="M40.0412 21H49V35.9355C49 38.3118 48.4546 40.0591 47.3638 41.1774C46.1649 42.3817 44.2047 42.9839 41.4831 42.9839H40.0412V21ZM16 21H24.9588V42.9839H23.5169C19.5317 42.9839 17.1556 41.6398 16.3888 38.9516C16.1296 38.0806 16 37.0753 16 35.9355V21ZM28.0044 21.0161H37.0118V43H28.0044V21.0161Z"
          fill="#001657"
        />
        <defs>
          <linearGradient id="paint0_linear_1812_4022" x1="32" y1="0" x2="32" y2="64" gradientUnits="userSpaceOnUse">
            <stop stopColor="#BBE0F1" />
            <stop offset="1" stopColor="#91CDE8" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

export default WinterizationLogo;
